import React, { FC } from "react";

interface AchievementCardType {
    imagePath?: string;
    imageTitle: any;
    count: string;
    by?: string;
    borderColor: string;
    boxShadowColor: string;
    fontColor: string;
    gradient: string;
    customHeight?: boolean;
    customPadding?: boolean;
}

const AchievementCard: FC<AchievementCardType> = ({ customPadding, imagePath, imageTitle, count, by, borderColor, boxShadowColor, customHeight, fontColor, gradient }) => {
    const styles = {
        background: gradient,
        border: `2px solid ${borderColor}`,
        boxShadow: `0px 20px 40px ${boxShadowColor}`,
        color: `${fontColor}`,
    };
    return (
        <div className="flex flex-col items-center justify-center text-center achievementcard " style={{ ...styles, padding: customPadding ? "0px 55px !important" : "0px" }}>
            <img className=" w-10 h-8" src={imagePath} alt="" />
            <p className={`count mt-1 ${customHeight ? "mt-6" : ""}`}>{count}</p>
            <p className="by">{imageTitle}</p>
            <p className="by">{by}</p>
        </div>
    );
};

export default AchievementCard;
